module.exports = __webpack_public_path__ + "static/media/Then I Came.3acc1529.jpg";